import React from 'react';
import { CardProjectUserStyle, WrapperCard, CardProject } from './style';
import StatusBarHeaderConsult from '../StatusBarHeaderConsult';

export default function CardProjectUser({ project }) {
  return (
    <CardProjectUserStyle>
      <StatusBarHeaderConsult project={project} />
      <h3>Cliente - Projeto - Empresa</h3>
      <WrapperCard>
        {project.project.map((individualProject, IndividualIndex) => {
          return (
            <CardProject key={IndividualIndex + 1}>
              <h3>{individualProject.clientAndProject}</h3>
              <div>
                <p>{individualProject.rateio}%</p>
                <p>{individualProject.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
              </div>
            </CardProject>
          );
        })}
      </WrapperCard>
      {project.links.length > 0 ? <h3>Itens Anexados</h3> : <h3>Nenhum item anexado no momento.</h3>}
      <WrapperCard>
        {project.links.map((link, linkIndex) => {
          return (
            <div key={linkIndex + 1}>
              {link.upload !== null && (
                <a href={link.upload.url} target="_blank" rel="noreferrer">
                  {link.upload.name}
                </a>
              )}
            </div>
          );
        })}
      </WrapperCard>
    </CardProjectUserStyle>
  );
}
